// extracted by mini-css-extract-plugin
module.exports = {"container":"truncated-group__container___dz2_D","shown":"truncated-group__shown___39sTE","hidden":"truncated-group__hidden___1p7wD"};